import React, { useCallback } from "react";
import { TreeItem as MUITreeItem } from "@material-ui/lab";
import type { FC, MouseEvent } from "react";
import { useParentStyles, useItemStyles } from "./TreeItem.styles";
import type { ITreeItemProps } from "./TreeItem.types";

export const TreeItem: FC<ITreeItemProps> = (props) => {
  const { onSelect, hierarchy } = props;
  const classesParent = useParentStyles();
  const classesItem = useItemStyles();

  const id = hierarchy.id;

  const handleLabelClick = useCallback(
    (e: MouseEvent) => {
      onSelect?.(id);
      e.stopPropagation();
    },
    [id, onSelect]
  );

  if (hierarchy.children.length) {
    return (
      <MUITreeItem role="listitem" nodeId={String(id)} label={hierarchy.name} classes={classesParent} onLabelClick={handleLabelClick}>
        {hierarchy.children.map((child) => (
          <TreeItem key={child.id} onSelect={onSelect} hierarchy={child} />
        ))}
      </MUITreeItem>
    );
  }

  return <MUITreeItem role="listitem" nodeId={String(id)} label={hierarchy.name} classes={classesItem} />;
};
